import React, { Component } from 'react';
import classNames from 'classnames';

const theme = {
	buttonWrapper: 'qa-r-editor-btn-wrap',
	button: 'qa-r-editor-btn',
	actived: 'actived',
	disabled: 'disabled'
};

export class Toolbar extends Component {
	state = {}

	widgetInstances = {}

	/** @type {HTMLDivElement} */
	element = null;

	/** @type {DraftEditorPlugin[]} */
	get plugins() {
		return this.props.plugins;
	}

	get toolbarProvide() {
		const { store } = this.props;
		const env = store.getEditorEnviorment();
		const getWidget = this.getWidget;
		return { store, theme, env, getWidget };
	}

	/** @type {DraftEditorToolbarWidget[]} */
	gePluginWidgets(props) {
		return this.plugins.reduce((widgets, plugin) => {
			if (!plugin.getToolbarWidgets) {
				return widgets;
			}
			return widgets.concat(plugin.getToolbarWidgets(props))
		}, []);
	}

	getWidget = key => this.widgetInstances[key];

	render() {
		const { store, plugins } = this.props;
		const env = store.getEditorEnviorment();
		const getWidget = this.getWidget;
		const provide = this.toolbarProvide;

		return (
			<div
				className="qa-r-editor-toolbar"
				ref={element => this.element = element}
				onMouseDown={e => /** 防止编辑器丢失焦点 */ e.preventDefault()}>
				<section className="qa-r-editor-btns">
					{ this.renderToolbarButtons(provide) }
				</section>
				{ this.renderToolbarWidgets(provide) }
			</div>
		);
	}

	renderToolbarButtons(provide) {
		const buttons = this.plugins.reduce((buttons, { getToolbarButtons }) => (
			getToolbarButtons ? [
				...buttons,
				...(getToolbarButtons(provide) || [])
			] : buttons
		), []);
		return buttons.map(
			(button, index) => button === 'spliter'
				? <span key={`spliter-${index}`} className="qa-r-editor-spliter">|</span>
				: button
		);
	}

	renderToolbarWidgets(provide) {
		const isStateless = component => !component.prototype.render;
		const createWidgetRef = ({ key, component }) => {
			// stateless function does not support refs
			if (isStateless(component)) {
				return null;
			}
			return widget => this.widgetInstances[key] = widget;
		};
		const createWidgetProps = (widget) => ({
			key: widget.key,
			ref: createWidgetRef(widget),
			...provide,
			...(widget.props || {}),
		});
		const renderWidget = widget => React.createElement(widget.component, createWidgetProps(widget));
		return this.gePluginWidgets(provide).filter(x => x.component).map(renderWidget);
	}

	componentDidMount() {
		for (let { onToolbarMount } of this.gePluginWidgets(this.toolbarProvide)) {
			if (typeof onToolbarMount === 'function') {
				onToolbarMount(this, this.props.store);
			}
		}
	}

	componentWillUnmount() {
		for (let { onToolbarUnmount } of this.gePluginWidgets(this.toolbarProvide)) {
			if (typeof onToolbarUnmount === 'function') {
				onToolbarUnmount(this, this.props.store);
			}
		}
	}

	startStickToTop() {
		this.HEADER_HEIGHT = $('.col-editor-header').height();
		const scrollElement = $(window);
		this.scrollElement = scrollElement;
		scrollElement.on('scroll', this.checkStick);
		$(window).on('resize', this.checkStick);
	}

	stopStickToTop() {
		this.scrollElement.off('scroll', this.checkStick);
		$(window).off('resize', this.checkStick);
	}

	checkStick = () => {
		if (!this.element) return;
		const { top, left, right, width, bottom } = this.element.parentElement.getBoundingClientRect();
		if (bottom < this.HEADER_HEIGHT) {
			$(this.element).hide();
		}
		else if (top < this.HEADER_HEIGHT) {
			$(this.element).show().css({
				position: 'fixed',
				top: this.HEADER_HEIGHT,
				left: left,
				width: width,
				background: 'white',
				borderRadius: 0,
			});
		}
		else {
			$(this.element).show().css({
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
			});
		}
	}
};



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/toolbar/Toolbar.jsx